var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconDownloadLight = function SvgIconDownloadLight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 33.475v-8.4h2.2v8.4c0 1.393 1.107 2.5 2.5 2.5h18.8c1.392 0 2.5-1.107 2.5-2.5v-8.4h2.2v8.4c0 2.608-2.093 4.7-4.7 4.7H14.7a4.685 4.685 0 0 1-4.7-4.7Z",
    fill: "#121619"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.007 27V10h2.2v17h-2.2Z",
    fill: "#121619"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.727 28.034c-.89 1.054-2.435.907-3.298.044a.847.847 0 0 1-.019-.02l-6-6.3 1.593-1.517 5.987 6.287c.033.03.067.043.09.046l.036-.04 6.1-6.3 1.581 1.531-6.07 6.269Z",
    fill: "#121619"
  })));
};
export default SvgIconDownloadLight;